"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
var notFound_1 = require("./notFound");
Object.defineProperty(exports, "NotFound", { enumerable: true, get: function () { return __importDefault(notFound_1).default; } });
//# sourceMappingURL=index.js.map